module.exports = __webpack_public_path__ + "static/img/img2.5fe853c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/cooperation_case/img2.png
// module id = N7m9
// module chunks = 0